import { ObjectTypeFromIds } from 'customer-data-objects/constants/ObjectTypeIds';
import { getIn } from './getIn';

// CallableObject is instantiated in 'calling-lifecycle-internal/callees/records/CalleesRecords';

export function createDialNumberPayload({
  selectedCallee,
  phoneNumber,
  countryCode,
  selectedToNumberPropertyName,
  ownerId,
  portalId,
  subjectId,
  objectTypeId,
  threadId = 0,
  extension = ''
}) {
  if (!selectedCallee || !phoneNumber) {
    return null;
  }
  const calleeId = getIn(['objectId'], selectedCallee);
  const calleeObjectTypeId = getIn(['objectTypeId'], selectedCallee);
  const objectType = ObjectTypeFromIds[objectTypeId];
  return {
    phoneNumber,
    phone_number: phoneNumber,
    // for aircall,
    extension,
    countryCode,
    calleeInfo: {
      calleeId,
      calleeObjectTypeId
    },
    ownerId,
    subjectId,
    objectId: subjectId,
    objectTypeId,
    objectType,
    startTimestamp: Date.now(),
    portalId,
    toPhoneNumberSrc: selectedToNumberPropertyName,
    threadId
  };
}